import type { ReactNode } from "react";

/** Narrow centred layout of the template's login page. */
export function AuthShell({
  eyebrow,
  title,
  subtitle,
  children,
}: {
  eyebrow: string;
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="mx-auto flex max-w-md flex-col px-5 py-24">
      <p className="eyebrow text-gold">{eyebrow}</p>
      <h1 className="mt-3 text-4xl">{title}</h1>
      {subtitle && <p className="mt-3 text-sm text-muted-foreground">{subtitle}</p>}
      <div className="mt-9">{children}</div>
    </div>
  );
}

/** Only same-app relative paths are accepted as redirect targets. */
export function safeRedirect(target: string | undefined, fallback = "/dashboard") {
  return target && target.startsWith("/") && !target.startsWith("//") ? target : fallback;
}
